// Overlay marks U+0334-U+0338 negate meaning rather than decorate, so they stay and degrade to '?'.
const DECORATIVE_MARKS = /[\u0300-\u0333\u0339-\u036f]/g;

const stripDiacritics = (value: string): string =>
  value.normalize('NFD').replace(DECORATIVE_MARKS, '');

export default stripDiacritics;
